import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import { useSvgId } from '../../primitives/useSvgId.js';
import type { IconProps } from '../../primitives/types.js';

/** Git — trunk + branch. A commit dot travels from the base node out along
 *  the arc to the merge target, visualising "merge" / "push" flow. */
export function IcnGit(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  const pathId = useSvgId('git-flow');
  return (
    <Svg {...props} iconName="git">
      <path id={pathId} d="M4 6.5a5.5 5.5 0 0 0 5.5 1.5" strokeDasharray="1.5 1.5" fill="none" />
      <line x1="4" y1="5.5" x2="4" y2="10.5" />
      <circle cx="4" cy="4" r="1.5" fill="currentColor" />
      <circle cx="4" cy="12" r="1.5" fill="currentColor" />
      <circle cx="12" cy="8" r="1.5" fill="currentColor">
        {animate && (
          <animate
            attributeName="r"
            values="1.5;1.9;1.5"
            keyTimes="0;0.1;0.25"
            dur="2.4s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      {animate && (
        <circle r="0.8" fill="currentColor" stroke="none">
          <animateMotion dur="2.4s" repeatCount="indefinite" rotate="auto">
            <mpath xlinkHref={`#${pathId}`} />
          </animateMotion>
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            keyTimes="0;0.12;0.85;1"
            dur="2.4s"
            repeatCount="indefinite"
          />
        </circle>
      )}
    </Svg>
  );
}
